import styled from 'styled-components';

export const AssignmentDetails = styled.div`
  font-size: 14px;
  line-height: 19px;
  .ant-typography.ant-typography-secondary {
    color: var(--c_description);
  }
`;
